import { Toaster } from "sonner";
import { QueryProvider } from "./providers/QueryProvider";
import { AppRouterProvider } from "./providers/RouterProvider";

export function App() {
  return (
    <QueryProvider>
      <AppRouterProvider />
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          className: "font-sans",
        }}
      />
    </QueryProvider>
  );
}
